@use 'src/scss/mixins/button';
@use 'src/scss/mixins/controls';
@use 'src/scss/elements/styledButton';

@use 'src/scss/config/index' as config;

.nav {
  grid-area: nav;
}

.navList {
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  height: 100%;
  counter-reset: section;
  list-style: none;
  padding: 0;
  margin: 0;

  @media #{config.$md} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 50em;
  }
}

.navItem {
  margin: 0 0 1em;

  @media #{config.$md} {
    flex: 1;
    margin: 0 0.3em 0.3em;
  }
}

.navSection {
  composes: navItem;
}

.navItemButton {
  width: 100%;

  counter-increment: section;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 0.5em;
  text-align: left;

  &:before {
    content: counter(section);
    font-size: 0.8em;
    height: 1.4em;
    width: 1.4em;
    background-color: config.$dark;
    color: #fff;
    text-align: center;
    line-height: 1.4em;
    border-radius: 50%;
    margin-right: 0.5em;
    font-weight: bold;
  }

  &.active {
    @include button.activePrimary();
  }
}

.navSectionButton {
  composes: styledButton;
  width: 100%;
  font-weight: bold;
}
